<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options">
      <span
        slot="active"
        slot-scope="props"
      >{{ (props.row.login.active == true) ? "Oui" : "Non" }}</span>

      <div v-if="props.row.is_active==true" slot="is_active" slot-scope="props" class="slot-center">
        <span class="badge badge-success p-1"><i class="fa fa-check"></i></span>
      </div>
      <div v-else-if="props.row.is_active==false" slot="is_active" slot-scope="props" class="slot-center">
        <span class="badge badge-danger p-1"><i class="fa fa-close"></i></span>
      </div>
      <div v-else>
        <span></span>
      </div>

      <div v-if="props.row.id_pp" slot="id_pp" slot-scope="props" class="slot-number slot-idpp">
        <span><a class="fiche-beneficiaire slot-number" href="#" @click.prevent="fiche(props.row.id)">{{ props.row.id_pp }}</a></span>
      </div>

        <div v-if="props.row.nir" slot="nir" slot-scope="props" class="slot-number">
            <span>{{ formatNir(props.row.nir) }}</span>
        </div>

      <div v-if="props.row.numero_tel" slot="numero_tel" slot-scope="props" class="slot-number">
        <span>{{ props.row.numero_tel }}</span>
      </div>

      <div v-if="props.row.date_naissance" slot="date_naissance" slot-scope="props" class="slot-date">{{ formatDate(props.row.date_naissance) }}</div>
    </v-server-table>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "../utils/auth";

export default {
  name: "BeneficiaireTable",
  props: ["tableEntry"],
  data() {
    let self = this;
    return {
      url: '',
      columns: ["id_pp", "nir", "nom", "prenom", "numero_tel", "date_naissance", "is_active"],
      options: {
        headings: {
          id_pp: "N° Ident. NSI",
          nir : "N° Sécu. Soc.",
          num_dossier: "N° dossier",
          nom: "Nom",
          prenom: "Prénom",
          numero_tel: "Téléphone",
          date_naissance: "Date de naissance",
          is_active: "Contactable"
        },
        sortable: ["nom", "prenom"],
        filterable: false,
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: {
          filterPlaceholder: "Nom, Prénom, N°Identifiant NSI"
        },
        orderBy: { ascending: true},
        requestFunction: function (data) {
            self.url = '/espaceBeneficiaire/beneficiaires/recherche'
            data["idpp_criteria"] = self.tableEntry.idpp_criteria;
            data["dossier_criteria"] = self.tableEntry.dossier_criteria;
            data["nir_criteria"] = self.tableEntry.nir_criteria;
            data["nom_criteria"] = self.tableEntry.nom_criteria;
            data["prenom_criteria"] = self.tableEntry.prenom_criteria;
            data["active"] = self.tableEntry.active;
            data["is_active"] = self.tableEntry.is_active;
            data["email_criteria"] = self.tableEntry.email_criteria;
            // data["noSearch"] = self.tableEntry.noSearch;
            data["noSearch"] = self.$parent.noSearch;

            self.$store.commit("IS_LOADING", true);

            return axios.get(self.url, {
                params: data
            })
            .catch(function (e) {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 5000
              });
            }.bind(this));
        }
      }
    };
  },
  methods: {
    onLoaded(){
      this.$store.commit("IS_LOADING", false);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      return date;
    },
    fiche(id) {
      // this.$router.push({ path: '/espace-beneficiaire/beneficiaires/fiche/' + id })
      this.$router.push({ path: "/espace-beneficiaire/beneficiaires/fiche/" + id, query: { in: this.tableEntry.idpp_criteria, do: this.tableEntry.dossier_criteria, ns: this.tableEntry.nir_criteria, no: this.tableEntry.nom_criteria, pr: this.tableEntry.prenom_criteria, em: this.tableEntry.email_criteria, co: this.tableEntry.active, de: this.tableEntry.is_active }})
    },
    formatNir(textNir) {
      if(textNir !== null  && textNir !== ''){

        let nirs = textNir.split(',');
        let displayNir = '';

        nirs.forEach(function (element){
          if(element.length > 13){
            if(displayNir === ''){
              displayNir = element.substring(0,13);
            }else{
              displayNir = displayNir + '\n' + element.substring(0,13);
            }
          }
        });
        return displayNir;
      }else{
        return textNir;
      }
    }
  }
};
</script>

<style scoped>
.VueTables__search-field input {
  width: 240px !important; 
}
</style>